import '../styles/processNavigation.less';
import { addMutationHandlers } from '../../../shared/modules/domchange';
import {
    addClass,
    removeClass,
    shouldBeInitialized,
    invoke,
    markInitialized
} from '../../../shared/modules/common';

var ACTIVE_STEP_CLASS = 'uwr-process-navigation-current',
    COMPLETED_STEP_CLASS = 'uwr-process-navigation-complete',
    container,
    isGuided,
    allSteps;

function getActiveStepElement() {
    return container.querySelector('.' + ACTIVE_STEP_CLASS);
}

function setActive(stepNumber, skipForwardCheck) {
    var prevActive = getActiveStepElement(),
        prevActiveNumber = getStepNumber(prevActive),
        isAfterNextStep = stepNumber > prevActiveNumber + 1;

    // prevent moving forward more than one step in guided flows
    if (isGuided && isAfterNextStep && !skipForwardCheck) {
        return prevActiveNumber;
    }

    if (prevActive) {
        removeClass(prevActive, ACTIVE_STEP_CLASS);
    }
    if (stepNumber <= allSteps.length) {
        addClass(allSteps[stepNumber - 1], ACTIVE_STEP_CLASS);
    }

    return stepNumber;
}

function handleGuidedSteps(newStepNumber) {
    Array.prototype.forEach.call(allSteps, function (step) {
        var stepNumber = getStepNumber(step);
        complete(stepNumber, stepNumber < newStepNumber);
    });
}

export function complete(step, isCompleted) {
    if (isCompleted === undefined || isCompleted) {
        addClass(allSteps[step - 1], COMPLETED_STEP_CLASS);
    } else if (!isCompleted) {
        removeClass(allSteps[step - 1], COMPLETED_STEP_CLASS);
    }
}

function getStepNumber(item) {
    var stepNumber = 0,
        i;

    if (!item) {
            return stepNumber;
    }

    for (i = 0; i < allSteps.length; i++) {
        if (allSteps[i] === item) {
            stepNumber = i + 1;
            break;
        }
    }

    return stepNumber;
}

function getActiveStepNumber() {
    return getStepNumber(getActiveStepElement());
}

function limitStepNumber(step) {
    var lastStep = isGuided ? allSteps.length + 1 : allSteps.length;
    return Math.min(Math.max(1, step), lastStep);
}

export function active(step, skipGuidedCheck) {
    var limitedStep = setActive(limitStepNumber(step), skipGuidedCheck);
    if (isGuided) {
        handleGuidedSteps(limitedStep);
    }
}

export function next() {
    active(getActiveStepNumber() + 1);
}

export function back() {
    active(getActiveStepNumber() - 1);
}

function parseCompletedAttribute(attributeValue) {
    var sanitizedValue = (attributeValue && attributeValue.match(/-\d+|\d+/g)) || [];
    return JSON.parse('[' + sanitizedValue.join() + ']');
}

function updateCompletedStepsFromAttribute() {
    var completedAttribute = container.getAttribute('data-completed'),
        completedSteps,
        step,
        isCompleted;

    if (!isGuided) {
        completedSteps = parseCompletedAttribute(completedAttribute);

        for (step = 1; step <= allSteps.length; step++) {
            isCompleted = completedSteps.indexOf(step) > -1;
            complete(step, isCompleted);
        }
    }
}

function initProcessNavigation(container) {
    var activeStepNumber;

    if (!shouldBeInitialized(container)) {
        return;
    }

    isGuided = container.tagName === 'OL';
    allSteps = container.getElementsByTagName('li');

    activeStepNumber = parseInt(container.getAttribute('data-active'), 10) || getActiveStepNumber() || 1;

    active(activeStepNumber, true);

    if (container.hasAttribute('data-completed')) {
        updateCompletedStepsFromAttribute();
    }

    addMutationHandlers(container, {
        node: {
            'data-active': function () {
                var activeStepNumber = parseInt(container.getAttribute('data-active'), 10);
                if (!isNaN(activeStepNumber)) {
                    active(activeStepNumber, true);
                }
            },
            'data-completed': updateCompletedStepsFromAttribute
        }
    });

    markInitialized(container);
}

export function init(selector, callback) {
    var callbackWithoutSelector = arguments.length === 1 && typeof selector === 'function';
    if (arguments.length === 0 || callbackWithoutSelector) {
        container = document.querySelector('.uwr-process-navigation');
        if (container) {
            initProcessNavigation(container);
        }
        if (callbackWithoutSelector) {
            invoke(selector);
        }
    } else {
        if (typeof selector === 'string') {
            container = document.querySelector(selector);
        } else {
            container = selector;
        }
        initProcessNavigation(container);
        invoke(callback);
    }
}



//////////////////
// WEBPACK FOOTER
// ./widgets/ProcessNavigation/js/processNavigation.js
// module id = 36
// module chunks = main